function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { buildTypography } from "../buildTypography/buildTypography";
import { isDevEnv, devMessage } from "../../../utils/devMessage";
export function addTypographyToTheme(theme) {
    try {
        return _objectSpread({}, theme, {
            typography: _objectSpread({}, buildTypography(theme))
        });
    } catch (error) {
        if (isDevEnv()) {
            devMessage("[addTypographyToTheme] Typography has not been added to your style object. \nThere's an issue with the format of your Theme object. \nCheck your Tokens version and any modifications you may have made. \n Received \n".concat(JSON.stringify(theme, undefined, 2)));
        }
        return theme;
    }
}
export default addTypographyToTheme;
